import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ClipboardList } from "lucide-react";
import { useWizard } from "./WizardProvider";

export const MobileCtaBar = () => {
  const { openWizard } = useWizard();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const footer = document.querySelector('[data-testid="site-footer"]');
    if (!footer) return;
    const obs = new IntersectionObserver(([e]) => setHidden(e.isIntersecting), { threshold: 0.08 });
    obs.observe(footer);
    return () => obs.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 z-[60] lg:hidden glass rounded-full border border-white/15 p-2 flex gap-2 shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
          data-testid="mobile-cta-bar"
        >
          <a
            href="tel:0413328202"
            data-testid="mobile-cta-call"
            className="flex-1 rounded-full py-3 font-display text-sm font-bold text-white/90 border border-white/20 hover:border-[#00E676]/60 transition-colors duration-300 inline-flex items-center justify-center gap-2"
          >
            <Phone size={15} className="text-[#00E676]" /> Call 0413 328 202
          </a>
          <button
            onClick={() => openWizard()}
            data-testid="mobile-cta-query"
            className="flex-1 rounded-full py-3 font-display text-sm font-bold text-white bg-gradient-to-r from-[#FF3D00] to-[#FF1744] shadow-[0_0_20px_rgba(255,23,68,0.35)] inline-flex items-center justify-center gap-2"
          >
            <ClipboardList size={15} /> Start Query
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
